import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { createDepthMeasurementRecord, deleteDepthMeasurementRecord, getDepthMeasurementRecords, updateDepthMeasurementRecord } from "../../api/captures/depthMeasurement";
import { DepthMeasurementRecordForm } from "../../types/forms/capture";

export const useCaptureDepthMeasurement = (captureIdStr?: string) => {
  const queryClient = useQueryClient();
  const captureId = Number(captureIdStr);

  const queryKey = ["capture", captureId, "depth-measurement"];

  const result = useQuery({
    queryKey,
    queryFn: () => getDepthMeasurementRecords(captureId),
    enabled: !!captureId,
  });

  const createMutation = useMutation({
    mutationFn: (values: DepthMeasurementRecordForm) => createDepthMeasurementRecord(captureId, values),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey });
    },
  });

  const updateMutation = useMutation({
    mutationFn: ({ recordId, values }: { recordId: number; values: DepthMeasurementRecordForm }) => updateDepthMeasurementRecord(captureId, recordId, values),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey });
    },
  });

  const deleteMutation = useMutation({
    mutationFn: (recordId: number) => deleteDepthMeasurementRecord(captureId, recordId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey });
    },
  });

  return {
    depthMeasurementRecordsData: result.data ?? [],
    isPending: result.isPending,
    isError: result.isError,
    error: result.error,
    refetch: result.refetch,
    createDepthMeasurement: createMutation.mutateAsync,
    updateDepthMeasurement: updateMutation.mutateAsync,
    deleteDepthMeasurement: deleteMutation.mutateAsync,
    isUpdating: createMutation.isPending || updateMutation.isPending || deleteMutation.isPending,
  };
};
